import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";

const pathMap = {
	[Locale.cs]: "kontaktni-formular" as const,
} satisfies LocalizedString;

export function getContactFormAnchor(tenant: Tenant): string {
	return pathMap[tenant.locale];
}
